// @flow
import firestore from '../services/firestore';
import alertSchema from '../../server/shared/schemas/alert';

export default alertSchema(firestore);